import { Mark } from '@tiptap/core'

/* Mirrors the mark that @liveblocks/react-tiptap's own extension registers in
 * the collaborative editor's runtime schema. That vendor extension writes the
 * mark into stored note content, so every renderer that reads stored notes has
 * to know it exists or `generateHTML` throws on the note. Declared here so the
 * browser and the server render an annotated span the same way; the editor
 * takes the vendor's copy instead, since only that one carries the thread UI. */
export const LiveblocksCommentMark = Mark.create({
  name: 'liveblocksCommentMark',
  addAttributes() {
    return {
      threadId: { default: null },
      orphan: { default: false },
    }
  },
  renderHTML() {
    return ['span', {}, 0]
  },
})
